/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Player_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Video player" |
*
* @param {Player_Video_Player_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_player_aria_label = /** @type {((inputs?: Player_Video_Player_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Player_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecteur video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videoplayer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettore video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеоплеер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reproductor de video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频播放器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオプレーヤー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो प्लेयर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reprodutor de vídeo")
	return /** @type {LocalizedString} */ ("Video player")
});